import Expansions from 'components/pages/faq/Expansions';
import BackButton from '@core/components/backbutton/BackButton';
import Spinner from '@core/components/spinner/Spinner';

import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { queryClientConfig } from '@core/configs/queryClientConfig';
import { setSsrTokens } from 'utils/authentication';

import { faqService } from 'services/static';

import { NextSeo } from 'next-seo';
import { getFaqSeoProps } from 'router/seoprops';

import classes from './index.module.scss';

const FAQ = () => {
	const { data, isLoading } = useQuery('faq', faqService);
	const seoProps = getFaqSeoProps();
	return (
		<>
			<NextSeo {...seoProps} />
			<div className="container col-12 col-xl-8">
				<div className={`${classes['title-container']} d-none d-xl-flex flex-row`}>
					<BackButton type="bordered" />
					<div className={`${classes['page-title']}`}>FAQ</div>
				</div>
				{isLoading ? (
					<div className={classes['loading']}>
						<Spinner />
					</div>
				) : (
					data?.data && <Expansions data={data.data.results} />
				)}
			</div>
		</>
	);
};

export async function getServerSideProps() {
	const queryClient = new QueryClient(queryClientConfig);
	try {
		const response = await faqService();
		await queryClient.prefetchQuery('faq', () => ({ data: response.data }));
	} catch (e) {
		console.log(e);
	}
	return {
		props: {
			dehydratedState: dehydrate(queryClient)
		}
	};
}

export default FAQ;
